module.exports = __webpack_public_path__ + "6241d1de26f8989fd9bedb1a6c76248a.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/corporate-settings/corporate-settings.html
// module id = 1227
// module chunks = 0